export const notices = [
  {
    id: 1,
    title: "2024년 동절기 건물관리 서비스 안내",
    content: `안녕하십니까, 주식회사 두성시스템입니다.

동절기를 맞이하여 건물관리 서비스에 관한 안내 말씀을 드립니다.

■ 동절기 특별 점검 항목
- 난방 설비 점검 및 동파 방지 조치
- 외벽 및 옥상 방수 상태 점검
- 소방 설비 동절기 점검
- 제설 서비스 운영 (12월 ~ 2월)

■ 서비스 문의
전화: 031-871-4424/5
이메일: doosung0601@hanmail.net

고객님의 소중한 자산을 지키기 위해 최선을 다하겠습니다.

감사합니다.
주식회사 두성시스템 드림`,
    is_important: 1,
    created_at: "2024-11-15T09:00:00.000Z",
    view_count: 128
  },
  {
    id: 3,
    title: "추석 연휴 업무 안내 (2024)",
    content: `안녕하십니까, 주식회사 두성시스템입니다.

추석 연휴 기간 업무 운영에 관해 안내드립니다.

■ 휴무 기간: 2024년 9월 16일(월) ~ 9월 18일(수)
■ 업무 재개: 2024년 9월 19일(목)

긴급 시설 관리 사항은 비상 연락처(031-871-4424)로 연락주시기 바랍니다.

풍성하고 행복한 추석 명절 보내시기 바랍니다.
감사합니다.`,
    is_important: 0,
    created_at: "2024-09-10T09:00:00.000Z",
    view_count: 67
  },
  {
    id: 4,
    title: "하절기 방역·소독 서비스 신청 안내",
    content: `안녕하십니까, 주식회사 두성시스템입니다.

무더운 여름철을 맞아 방역·소독 서비스를 안내드립니다.

■ 서비스 내용
- 건물 내·외부 방역 소독
- 해충(바퀴벌레, 모기, 파리 등) 방제
- 저수조 청소 및 수질 검사
- 식당, 사무실, 공동주택 등 대상

■ 서비스 신청
전화: 031-871-4424/5
이메일: doosung0601@hanmail.net

신청 시 협의 후 일정을 조율하여 진행해드립니다.
감사합니다.`,
    is_important: 0,
    created_at: "2024-06-20T09:00:00.000Z",
    view_count: 84
  },
  {
    id: 5,
    title: "경기도 우수 사회적기업 선정",
    content: `안녕하십니까, 주식회사 두성시스템입니다.

저희 주식회사 두성시스템이 경기도 우수 사회적기업으로 선정되었음을 알려드립니다.

■ 선정 기관: 경기도청
■ 선정 사유: 지역사회 기여 및 취약계층 일자리 창출 우수

앞으로도 지역사회와 함께 성장하는 사회적기업으로서 역할을 다하겠습니다.
고객 여러분의 변함없는 성원에 감사드립니다.`,
    is_important: 0,
    created_at: "2024-04-15T09:00:00.000Z",
    view_count: 112
  },
  {
    id: 6,
    title: "2024년 설 연휴 업무 안내",
    content: `안녕하십니까, 주식회사 두성시스템입니다.

설 연휴 기간 업무 운영에 관해 안내드립니다.

■ 휴무 기간: 2024년 2월 9일(금) ~ 2월 12일(월)
■ 업무 재개: 2024년 2월 13일(화)

긴급 사항 발생 시 비상 연락처(031-871-4424)로 연락주시기 바랍니다.

새해 복 많이 받으시기 바랍니다.
감사합니다.`,
    is_important: 0,
    created_at: "2024-02-05T09:00:00.000Z",
    view_count: 58
  },
  {
    id: 7,
    title: "조경·식재 봄철 서비스 안내",
    content: `안녕하십니까, 주식회사 두성시스템입니다.

봄철을 맞아 조경·식재 서비스를 안내드립니다.

■ 서비스 내용
- 화단 정비 및 계절 식물 식재
- 잔디 관리 및 시비 작업
- 수목 전정 및 병충해 방제
- 조경 시설물 보수 및 교체

■ 서비스 문의
전화: 031-871-4424/5

쾌적하고 아름다운 환경을 만들어 드리겠습니다.
감사합니다.`,
    is_important: 0,
    created_at: "2024-03-05T09:00:00.000Z",
    view_count: 76
  }
];
